import {css, ThemedCssFunction} from "styled-components"

export const EXTRA_LARGE_DESKTOP = 1366
export const LARGE_DESKTOP = 1200
export const DESKTOP = 992
export const TABLET = 768
export const PHONE_LANDSCAPE = 576
export const PHONE = 376

export interface BreakPoints<T> {
  extraLargeDesktop: T
  largeDesktop: T
  desktop: T
  tablet: T
  phoneLandscape: T
  phone: T
}

export const sizes: BreakPoints<string> = {
  extraLargeDesktop: `${EXTRA_LARGE_DESKTOP - 1}px`,
  largeDesktop: `${LARGE_DESKTOP - 1}px`,
  desktop: `${DESKTOP - 1}px`,
  tablet: `${TABLET - 1}px`,
  phoneLandscape: `${PHONE_LANDSCAPE - 1}px`,
  phone: `${PHONE - 1}px`
}

const minWidthsizes: BreakPoints<string> = {
  extraLargeDesktop: `${EXTRA_LARGE_DESKTOP}px`,
  largeDesktop: `${LARGE_DESKTOP}px`,
  desktop: `${DESKTOP}px`,
  tablet: `${TABLET}px`,
  phoneLandscape: `${PHONE_LANDSCAPE}px`,
  phone: `${PHONE}px`
}

/** Match bootstrap's media queries, they work mobile first */
export const minWidthMedia: BreakPoints<ThemedCssFunction<any>> = Object.keys(sizes).reduce<BreakPoints<string>>((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${minWidthsizes[label]}) {
      ${css(...args)}
    }
  `
  return acc
}, {})

// Iterate through the sizes and create a media template
const maxWidthMedia: BreakPoints<ThemedCssFunction<any>> = Object.keys(sizes).reduce<BreakPoints<string>>((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}) {
      ${css(...args)}
    }
  `
  return acc
}, {})

export default maxWidthMedia
